import { BarChart3, MessageSquare, TrendingUp } from 'lucide-react';

export const REPORT_TABS = [
  { key: 'analytics', label: 'Analytics', icon: BarChart3 },
  { key: 'progress', label: 'Progress', icon: TrendingUp },
  { key: 'comments', label: 'Comments', icon: MessageSquare },
] as const;

export type ReportTabKey = (typeof REPORT_TABS)[number]['key'];
